import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { initModelsData, INIT_MODELS_FAIL, EDIT_MODEL_FAIL, SAVE_MODEL_FORM_FAIL } from '../../actions/maintenance/index';
import { forwardLogin } from '../../actions/login/index';
import ModelList from '../../components/maintenance/ModelList';
import Loading from '../../components/common/Loading';

class ModelListPage extends Component {
  renderList = () => {
    const { loading } = this.props;

    let displayList;
    if (loading) {
      displayList = <Loading loading={loading}></Loading>;
    } else {
      displayList = <ModelList></ModelList>;
    }

    return (
      <div className='custom-list model-list'>
        {displayList}
      </div>
    )
  }

  componentDidMount() {
    const { idToken, initModelsData, models } = this.props;
    if (models.length === 0) {
      if (idToken) {
        initModelsData(idToken, null);
      }      
    }
  }
  
  componentDidUpdate (prevProps, prevState, snapshot) {
    const { forwardLogin, status, history } = this.props;
    if (prevProps.status !== status) {
      if (status === INIT_MODELS_FAIL || status === EDIT_MODEL_FAIL || status === SAVE_MODEL_FORM_FAIL) {
        forwardLogin("Connect timeout, please relogin.");
        history.push("/Login");
      }
    }
  }

  render() {
    return this.renderList();
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    idToken: state.logindReducers.idToken,
    status: state.maintenanceReducers.status,
    models: state.maintenanceReducers.models,
    loading: state.maintenanceReducers.loading
  }
}

export default withRouter(connect(
  mapStateToProps, 
  { forwardLogin, initModelsData }
)(ModelListPage))
